<script>
		
</script>

<main>
	
	<h1>Covid-19 Update</h1>
	<hr>
	<br>
	<p>The health and safety of our patients and staff members is our top priority.  At our office, we continue to use Universal Precautions along with infection control protocols and standards of the American Dental Association (ADA), the U.S. Center for Disease Control (CDC), the Occupational Safety and Health Administration (OSHA), and the Washington State Department of Health.  We are trained to prevent the spread of infectious diseases such as the flu, HIV, hepatitis, and tuberculosis.  These precautions that we take every day will also help prevent the spread of Coronavirus.  We are also adhering to the new guidelines and precautions outlined by these agencies.</p>
	<br>
	<p>We are currently seeing patients for all services and procedures; however, there are some changes to help protect our patients and staff. We will be asking screening questions and temperature will be taken.  We are scheduling only one patient/family at one time in the office.  The office, including the reception area, is sanitized after each patient.  We ask that you wear your mask or face covering when you come to our office.  <b>We ask that you be on time for your appointment.  If you arrive early, please wait inside your car until your scheduled appointment time to make sure the office is sanitized before you come inside.</b> There may be limited options for appointment times; therefore, we recommend scheduling your next appointment as soon as you are able.  If you do not have dental insurance, please ask us about our Shoreline Family Dentistry Plan. </p>
	<br>
	<p>Thank you for being our patient. We look forward to seeing you and are happy to answer any questions you may have.  Please call our office at <a href="tel:+2065462322">206-546-2322</a> or email us at <a href="mailto:info@shorelinefamilydentistry.com?subject=Subject">info@shorelinefamilydentistry.com</a>.</p>

</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
	}
</style>